/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import detailModule, { StoreChatConversationDetailState } from './detail';
import listModule, { StoreChatConversationListState } from './list';

export interface StoreChatConversationState {
  detail: StoreChatConversationDetailState;
  list: StoreChatConversationListState;
}

export default {
  namespaced: true,
  modules: {
    detail: detailModule,
    list: listModule,
  },
  state: {},
  actions: {},
  mutations: {
  },
};
